import { Box, Typography } from "@mui/material";

interface Props {
  label: string;
  required?: boolean;
  htmlFor?: string;
}

export function FieldLabel({ label, required, htmlFor }: Props): React.ReactElement {
  return (
    <Box
      component="label"
      htmlFor={htmlFor}
      sx={{ display: "block", mb: 0.5 }}
    >
      <Typography
        variant="caption"
        component="span"
        sx={{ fontWeight: 600, fontSize: 13 }}
      >
        {label}
        {required === true ? (
          <Typography component="span" sx={{ color: "error.main", ml: 0.5 }}>
            *
          </Typography>
        ) : null}
      </Typography>
    </Box>
  );
}
